module.exports = __webpack_public_path__ + "static/media/Balance-m-female.71361d92.svg";